import { render, staticRenderFns } from "./CollisionViz.vue?vue&type=template&id=71509f07&scoped=true"
import script from "./CollisionViz.vue?vue&type=script&lang=js"
export * from "./CollisionViz.vue?vue&type=script&lang=js"
import style0 from "./CollisionViz.vue?vue&type=style&index=0&id=71509f07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71509f07",
  null
  
)

export default component.exports